/* @flow */
import React, { Component } from 'react';

type Props = {
    isProcessing: boolean,
    isFailed: boolean,
    isSuccessfull: boolean,
};

class PaymentProcessorForm extends Component<Props> {
    shouldComponentUpdate(nextProps) {
        return (
            this.props.isProcessing !== nextProps.isProcessing ||
            this.props.isFailed !== nextProps.isFailed ||
            this.props.isSuccessfull !== nextProps.isSuccessfull
        );
    }

    render() {
        const className =
            this.props.isProcessing &&
            !this.props.isFailed &&
            !this.props.isSuccessfull
                ? 'processing'
                : !this.props.isFailed
                    ? 'success'
                    : 'failed';
        return (
            <div id="spinholder" className={className}>
                {this.props.isProcessing}
                {this.props.isFailed}
                <div className="faileyes">
                    <div />
                    <div />
                </div>
                <div id="thespinner" />
                <div className="headline">
                    <h4>
                        <span id="processcontent" />
                    </h4>
                </div>
            </div>
        );
    }
}

export default PaymentProcessorForm;



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/PaymentProcessor/index.js